// extracted by mini-css-extract-plugin
module.exports = {"downloadOptions":"downloadDropdown_downloadOptions__RFBnN","active":"downloadDropdown_active__2C5yT"};